const initState = {
  financeError: null
};

const financeReducer = (state = initState, action) => {
  switch (action.type) {
    case 'ADD_TRANSACTION':
      console.log('💰 Transaction ajoutée avec succès sur Firestore');
      return {
        ...state,
        financeError: null
      };
    case 'ADD_TRANSACTION_ERR':
      console.error('❌ Erreur ajout transaction :', action.err);
      return {
        ...state,
        financeError: action.err.message
      };
    case 'DELETE_TRANSACTION':
      console.log('🗑️ Transaction supprimée avec succès sur Firestore');
      return {
        ...state,
        financeError: null
      };
    case 'DELETE_TRANSACTION_ERR':
      console.error('❌ Erreur suppression transaction :', action.err);
      return {
        ...state,
        financeError: action.err.message
      };
    case 'EDIT_TRANSACTION_SUCCESS':
      console.log('✏️ Edition effectuée avec succès sur Firestore');
      return {
        ...state,
        financeError: null
      };
    case 'EDIT_TRANSACTION_ERR':
      console.error('❌ Erreur édition transaction :', action.err);
      return {
        ...state,
        financeError: action.err.message
      };
    default:
      return state;
  }
};

export default financeReducer;